import { render, staticRenderFns } from "./FlexibleActivityPopup.vue?vue&type=template&id=504eee5e"
import script from "./FlexibleActivityPopup.vue?vue&type=script&lang=js"
export * from "./FlexibleActivityPopup.vue?vue&type=script&lang=js"
import style0 from "./FlexibleActivityPopup.vue?vue&type=style&index=0&id=504eee5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports